import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { provide } from 'vue'
import { ClassroomStudentServiceKey, ClassroomEventParams } from './ClassroomStudentService.interfaces'
import { createClassroomStudentService } from './ClassroomStudentService.composition'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassroomStudentService',
  props: {
    params: {}
  },
  setup(__props: any) {

const props = __props

const classroomStudentService = createClassroomStudentService(props.params)
provide(ClassroomStudentServiceKey, classroomStudentService)

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { service: _unref(classroomStudentService) })
}
}

})